import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import styles from './ManagementOpinionRow.module.sass'
import React, { memo } from 'react'

import Tooltip from '@jimmyboys/liita-ui/dist/components/Tooltip'
import Avatar from '@jimmyboys/liita-ui/dist/components/Avatar'
import FuseHighlight from 'components/FuseHighlight/FuseHighlight'

const ManagementOpinionRow = memo(
	(props) => {
		const { item, action } = props
		const { processId, submittedMedicalRequest, creationDate } = item

		return (
			<HStack
				className={styles['opinion-row']}
				gap='xsmall'
				justify='space-between'
				align='center'
			>
				<HStack gap='xsmall' align='center'>
					<Tooltip text={item?.creationUser?.name || ''}>
						<div className={styles['avatar-container']}>
							<Avatar
								rounded
								className={styles['avatar']}
								user={item?.creationUser}
							/>
						</div>
					</Tooltip>

					<Tooltip text={submittedMedicalRequest || ''}>
						<div className={styles['opinion-text']}>
							<FuseHighlight
								className={styles['opinion-text']}
								matchedWords={
									item?.$textHighlight?.matchedIndexes?.[
										'submittedMedicalRequest'
									]
								}
								text={submittedMedicalRequest}
							/>
						</div>
					</Tooltip>
				</HStack>

				<HStack
					className={styles['right-container']}
					gap='small'
					align='center'
				>
					{processId && (
						<div
							className={styles['process-link']}
							onClick={() => {
								action && action()
							}}
						>
							<small>
								#
								<FuseHighlight
									className={styles['opinion-text']}
									matchedWords={
										item.$textHighlight?.matchedIndexes?.[
											'processId'
										]
									}
									text={`${processId}`}
								/>
							</small>
						</div>
					)}
					<div>
						{creationDate?.shortDateFormat && (
							<span>
								<small>{creationDate?.shortDateFormat}</small>
							</span>
						)}
					</div>
				</HStack>
			</HStack>
		)
	},
	(prevProps, nextProps) =>
		prevProps.item.processId === nextProps.item.processId &&
		prevProps.item.submittedMedicalRequest ===
			nextProps.item.submittedMedicalRequest &&
		prevProps.item.creationDate === nextProps.item.creationDate &&
		prevProps.item.$textHighlight?.matchedIndexes ===
			nextProps.item.$textHighlight?.matchedIndexes
)

export default ManagementOpinionRow
